import React from 'react';
import SEO from '../components/SEO';
import { COMPANY, isFilled } from '../data/company';
import './LegalPage.css';

const AboutPage = () => (
  <div className="legal-page">
    <SEO
      title="Hakkımızda"
      description="isBulsun.com, yapay zeka destekli iş arama ve kariyer yönetim platformudur."
      path="/hakkimizda"
    />
    <div className="legal-page__container">
      <h1>Hakkımızda</h1>

      <p>
        <strong>{COMPANY.brand}</strong>, {COMPANY.legalName} tarafından geliştirilen,
        yapay zeka destekli kişisel bir kariyer ve ilan otomasyon asistanı yazılımıdır (SaaS).
        Siz uyurken bile yapay zeka asistanınız iş ilanlarını sizin adınıza tarar ve profilinize
        en uygun olanları bulur; amacımız iş arayanların doğru pozisyonlara daha hızlı
        ulaşmasını sağlamaktır.
      </p>

      <p>
        <strong>{COMPANY.brand}, bir işe yerleştirme garantisi sunan kurum veya işe aracılık
        kurumu değildir.</strong> Sunduğumuz hizmet; Veri Analiz ve Form Taslak Hazırlama
        Yazılımı kullanım lisansıdır. Onay verdiğiniz ilanlar için yazılım form taslağını
        hazırlar, gönderim yalnızca sizin onayınızla gerçekleşir. İşe alım kararı ve süreci
        tamamen işverene ve adaya aittir; iş garantisi vermeyiz.
      </p>

      <h2>Ne Yapıyoruz?</h2>
      <p>
        Klasik iş arama süreci; onlarca ilanı tek tek incelemeyi, her pozisyon için CV'yi
        yeniden düzenlemeyi ve başvuru formlarını tekrar tekrar doldurmayı gerektirir.{' '}
        {COMPANY.brand} bu adımları otomatikleştirir:
      </p>
      <ul>
        <li><strong>Akıllı CV oluşturma:</strong> Sohbet ederek veya mevcut CV'nizi yükleyerek dakikalar içinde profesyonel bir özgeçmiş hazırlarsınız.</li>
        <li><strong>İlan uyum analizi:</strong> Bir ilan bağlantısını yapıştırın, CV'nizin o pozisyona ne kadar uyduğunu, ATS uyumluluğunu ve eksik yönlerinizi görün.</li>
        <li><strong>Akıllı ilan eşleştirme ve form taslağı hazırlama:</strong> Siz uyurken dahi yapay zeka ilanları taramaya devam eder; profilinizle yüksek eşleşen ilanlar için, verdiğiniz onay dahilinde başvuru formu taslağını hazırlar. Gönderim yalnızca sizin onayınızla gerçekleşir; tüm işlemler panelinizden takip edilir.</li>
        <li><strong>Mülakat pratiği:</strong> Yapay zeka ile başvurduğunuz pozisyona özel mülakat simülasyonu yaparsınız.</li>
        <li><strong>Yurt dışı rehberliği:</strong> ABD ve Kanada'da çalışmak isteyen adaylar için vize uygunluğu ve kültürel uyum değerlendirmesi sunulur.</li>
      </ul>

      <h2>Yaklaşımımız</h2>
      <p>
        Yapay zekayı bir aracı olarak değil, adayın yanında çalışan bir asistan olarak
        konumlandırıyoruz. Verileriniz size aittir; CV'niz, form geçmişiniz ve kariyer
        profiliniz yalnızca size hizmet sunmak için işlenir. Form taslağı hazırlama onayınızı
        dilediğiniz zaman geri alabilirsiniz. Ayrıntılar{' '}
        <a href="/gizlilik">Gizlilik Politikası</a> ve{' '}
        <a href="/kullanim-kosullari#dijital-temsil">Dijital Temsil ve Otomasyon Açık Rıza Onayı</a>
        {' '}sayfalarımızda açıklanmıştır.
      </p>

      <h2>Kurumsal Bilgiler</h2>
      <ul>
        <li><strong>Ticari Ünvan:</strong> {COMPANY.legalName}</li>
        <li><strong>Marka:</strong> {COMPANY.brand}</li>
        <li><strong>Adres:</strong> {COMPANY.address}</li>
        <li><strong>Telefon:</strong> {COMPANY.phone}</li>
        <li><strong>E-posta:</strong> <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
        <li><strong>Vergi Dairesi / No:</strong> {COMPANY.taxOffice} / {COMPANY.taxNumber}</li>
        {isFilled(COMPANY.mersis) && <li><strong>MERSİS No:</strong> {COMPANY.mersis}</li>}
        {isFilled(COMPANY.kep) && <li><strong>KEP Adresi:</strong> {COMPANY.kep}</li>}
      </ul>

      <h2>İletişim</h2>
      <p>
        Soru, öneri ve talepleriniz için{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> adresinden veya{' '}
        {COMPANY.phone} numaralı telefondan bize ulaşabilirsiniz.
      </p>
    </div>
  </div>
);

export default AboutPage;
